import * as React from 'react';

function Box(props) {
    const { children, className, title, subtitle, width, height } = props;
    return (React.createElement("div", { className: className, style: {
            backgroundColor: "white",
            padding: "40px",
            borderRadius: "12px",
            boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
            width,
            height,
            textAlign: "center",
        } },
        title && (React.createElement("h1", { className: "text-3xl", style: { color: "#333" } }, title)),
        subtitle && (React.createElement("p", null, subtitle)),
        children));
}

function Container(props) {
    const { children, className } = props;
    return React.createElement("div", { className: `px-2 md:px-8 ${className}` }, children);
}

function Divider(props) {
    const { className } = props;
    return React.createElement("div", { className: `border-b my-8 border-slate-200 ${className}` });
}

function Section(props) {
    const { children, className, style } = props;
    return (React.createElement("section", { className: `mb-4 bg-white lg:mb-8 ${className}`, style: style }, children));
}
function Article(props) {
    const { children, className, style } = props;
    return (React.createElement("article", { className: `mb-4 bg-white lg:mb-8 ${className}`, style: style }, children));
}

function P(props) {
    const { children, className } = props;
    return (React.createElement("p", { className: `text-base md:text-lg lg:text-xl lg:leading-loose ${className}` }, children));
}
function H1(props) {
    const { children, className } = props;
    return (React.createElement("h1", { className: `font-bold text-xl md:text-2xl lg:text-3xl my-3 lg:my-5 ${className}` }, children));
}
function H2(props) {
    const { children, className } = props;
    return (React.createElement("h2", { className: `font-bold text-lg md:text-xl lg:text-2xl my-2 md:my-3 lg:my-5 ${className}` }, children));
}
function H3(props) {
    const { children, className } = props;
    return (React.createElement("h3", { className: `text-slate-500 my-1 lg:my-2 font-bold ${className}` }, children));
}
function List(props) {
    const { className, data } = props;
    return (React.createElement("ul", { className: `list-disc list-inside mt-5 ml-5 lg:mt-10 lg:ml-10 text-base lg:text-xl ${className}` }, data.map((el, i) => (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement("li", { key: i }, el)))));
}
function Bold() { }
function Italics() { }

export { Article, Bold, Box, Container, Divider, H1, H2, H3, Italics, List, P, Section };
//# sourceMappingURL=index.js.map
